import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { UserDetailDataFragmentDoc } from '../../../user/user.generated';
export type PersonSimpleDetailData_Person_Fragment = {
  __typename?: 'Person';
  id: any;
  createdAt: any;
  title?: string | null;
  gender?: Types.Gender | null;
  firstName?: string | null;
  lastName?: string | null;
  anonymizedAt?: any | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  inquiries: Array<{
    __typename?: 'Inquiry';
    id: any;
    createdAt: any;
    status: Types.InquiryStatus;
    assignee?: {
      __typename?: 'Administrator';
      id: any;
      fullName: string;
    } | null;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
};

export type PersonSimpleDetailData_PersonWithDuplicates_Fragment = {
  __typename?: 'PersonWithDuplicates';
  id: any;
  createdAt: any;
  title?: string | null;
  gender?: Types.Gender | null;
  firstName?: string | null;
  lastName?: string | null;
  anonymizedAt?: any | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  inquiries: Array<{
    __typename?: 'Inquiry';
    id: any;
    createdAt: any;
    status: Types.InquiryStatus;
    assignee?: {
      __typename?: 'Administrator';
      id: any;
      fullName: string;
    } | null;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
};

export type PersonSimpleDetailDataFragment =
  | PersonSimpleDetailData_Person_Fragment
  | PersonSimpleDetailData_PersonWithDuplicates_Fragment;

export type PersonDetailData_Person_Fragment = {
  __typename?: 'Person';
  internalNotes?: string | null;
  enterpriseIds?: Array<any> | null;
  id: any;
  createdAt: any;
  title?: string | null;
  gender?: Types.Gender | null;
  firstName?: string | null;
  lastName?: string | null;
  anonymizedAt?: any | null;
  employments: Array<{
    __typename?: 'Employment';
    id: any;
    description?: string | null;
    companyId: any;
    company: { __typename?: 'Company'; id: any; name: string };
  }>;
  enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
  user?:
    | {
        __typename?: 'Administrator';
        roleIds?: Array<any> | null;
        isBot: boolean;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Customer';
        invoiceEmail?: string | null;
        customerNumber?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        orders: Array<{
          __typename?: 'Order';
          id: any;
          createdAt: any;
          total: number;
        }>;
        bookings: Array<
          | {
              __typename?: 'CourseModuleBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseModule: {
                __typename?: 'CourseModule';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              };
            }
          | {
              __typename?: 'CourseUnitBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseUnit: {
                __typename?: 'CourseUnit';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                course: {
                  __typename?: 'Course';
                  id: any;
                  title: string;
                  verboseTitle?: string | null;
                  abbreviation: string;
                };
              };
            }
        >;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Teacher';
        jobTitle?: string | null;
        subjectArea?: string | null;
        slug?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  inquiries: Array<{
    __typename?: 'Inquiry';
    id: any;
    createdAt: any;
    status: Types.InquiryStatus;
    assignee?: {
      __typename?: 'Administrator';
      id: any;
      fullName: string;
    } | null;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
};

export type PersonDetailData_PersonWithDuplicates_Fragment = {
  __typename?: 'PersonWithDuplicates';
  internalNotes?: string | null;
  enterpriseIds?: Array<any> | null;
  id: any;
  createdAt: any;
  title?: string | null;
  gender?: Types.Gender | null;
  firstName?: string | null;
  lastName?: string | null;
  anonymizedAt?: any | null;
  employments: Array<{
    __typename?: 'Employment';
    id: any;
    description?: string | null;
    companyId: any;
    company: { __typename?: 'Company'; id: any; name: string };
  }>;
  enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
  user?:
    | {
        __typename?: 'Administrator';
        roleIds?: Array<any> | null;
        isBot: boolean;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Customer';
        invoiceEmail?: string | null;
        customerNumber?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        orders: Array<{
          __typename?: 'Order';
          id: any;
          createdAt: any;
          total: number;
        }>;
        bookings: Array<
          | {
              __typename?: 'CourseModuleBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseModule: {
                __typename?: 'CourseModule';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              };
            }
          | {
              __typename?: 'CourseUnitBooking';
              kind: Types.BookingKind;
              id: any;
              createdAt: any;
              courseUnit: {
                __typename?: 'CourseUnit';
                id: any;
                title?: string | null;
                sku: string;
                startDate: any;
                endDate: any;
                dateUncertain: boolean;
                withTime: boolean;
                online: boolean;
                correspondenceCourse: boolean;
                location?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                secondaryLocation?: {
                  __typename?: 'Location';
                  id: any;
                  commonName: string;
                } | null;
                course: {
                  __typename?: 'Course';
                  id: any;
                  title: string;
                  verboseTitle?: string | null;
                  abbreviation: string;
                };
              };
            }
        >;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | {
        __typename?: 'Teacher';
        jobTitle?: string | null;
        subjectArea?: string | null;
        slug?: string | null;
        id: any;
        username?: string | null;
        fullName: string;
        primaryEmail?: string | null;
        status: Types.UserStatus;
        description?: string | null;
        image?: { __typename?: 'FilesystemFile'; id: any; url: string } | null;
      }
    | null;
  contactProperties: Array<{
    __typename?: 'ContactProperty';
    id: any;
    key: Types.ContactPropertyKey;
    value: string;
  }>;
  inquiries: Array<{
    __typename?: 'Inquiry';
    id: any;
    createdAt: any;
    status: Types.InquiryStatus;
    assignee?: {
      __typename?: 'Administrator';
      id: any;
      fullName: string;
    } | null;
  }>;
  address: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
  invoiceAddress: {
    __typename?: 'Address';
    company?: string | null;
    contactPerson?: string | null;
    streetAndNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    other?: string | null;
  };
};

export type PersonDetailDataFragment =
  | PersonDetailData_Person_Fragment
  | PersonDetailData_PersonWithDuplicates_Fragment;

export const PersonSimpleDetailDataFragmentDoc = gql`
  fragment PersonSimpleDetailData on PersonInterface {
    id
    createdAt
    title
    gender
    firstName
    lastName
    anonymizedAt
    contactProperties {
      id
      key
      value
    }
    inquiries {
      id
      createdAt
      status
      assignee {
        id
        fullName
      }
    }
    address {
      company
      contactPerson
      streetAndNumber
      postalCode
      city
      country
      other
    }
    invoiceAddress {
      company
      contactPerson
      streetAndNumber
      postalCode
      city
      country
      other
    }
  }
`;
export const PersonDetailDataFragmentDoc = gql`
  fragment PersonDetailData on PersonInterface {
    ...PersonSimpleDetailData
    employments {
      id
      description
      companyId
      company {
        id
        name
      }
    }
    internalNotes
    enterprises {
      id
      name
    }
    enterpriseIds
    user {
      ...UserDetailData
    }
  }
  ${PersonSimpleDetailDataFragmentDoc}
  ${UserDetailDataFragmentDoc}
`;
